// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__0uezy {
  border-radius: 8px;
  display: inline-block;
  height: fit-content;
  border-radius: 50px;
  background: rgba(217, 217, 217, 0.5);
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: unset !important;
}
.styles_container__0uezy .styles_wrapper__aXU9y {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  height: 100%;
}
.styles_container__0uezy .styles_wrapper__aXU9y .styles_prefix__6RLnh,
.styles_container__0uezy .styles_wrapper__aXU9y .styles_affix__yC\\+GG {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.styles_container__0uezy .styles_wrapper__aXU9y input {
  background-color: transparent;
  width: 100%;
  border: none;
  cursor: default;
}
.styles_container__0uezy .styles_wrapper__aXU9y input:focus-visible {
  outline: 0;
}
@media screen and (max-width: 800px) {
  .styles_container__0uezy .styles_wrapper__aXU9y input {
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 20px;
    /* Gray 4 */
    color: #BDBDBD;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/AppInput/styles.module.scss"],"names":[],"mappings":"AAAA;EAEE,kBAAA;EAEA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,WAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AAFF;AAIE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAFJ;AAII;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFN;AAKI;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAHN;AAMI;EACE,UAAA;AAJN;AAcA;EAGM;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IAGA,WAAA;IAEA,cAAA;EAjBN;AACF","sourcesContent":[".container {\n  // background-color: #fafafa;\n  border-radius: 8px;\n  // border: 1px solid #eeeeee;\n  display: inline-block;\n  height: fit-content;\n  border-radius: 50px;\n  background: rgba(217, 217, 217, 0.50);\n  color: #000;\n  // font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  border: unset !important;\n\n  .wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 10px;\n    height:100%;\n\n    .prefix,\n    .affix {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor:pointer;\n    }\n\n    input {\n      background-color: transparent;\n      width: 100%;\n      border: none;\n      cursor:default;\n    }\n\n    input:focus-visible {\n      outline: 0;\n    }\n\n    input::placeholder {\n      // color: #bababa;\n    }\n  }\n}\n\n// @media only screen and (max-width: 576px) {\n@media screen and (max-width: 800px) {\n  .container {\n    .wrapper {\n      input {\n        font-style: normal;\n        font-weight: 300;\n        font-size: 12px;\n        line-height: 20px;\n\n\n        /* Gray 4 */\n\n        color: #BDBDBD;\n\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__0uezy`,
	"wrapper": `styles_wrapper__aXU9y`,
	"prefix": `styles_prefix__6RLnh`,
	"affix": `styles_affix__yC+GG`
};
export default ___CSS_LOADER_EXPORT___;
